import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom';
import { fetchLessons } from './actions';
import LessonEditPage from './LessonEditPage';
import Loading from '../../common/components/Loading';

class Lessons extends Component {
  componentDidMount() {
    const { dispatch, match, lessonsLoaded } = this.props;

    if (!lessonsLoaded) {
      dispatch(fetchLessons(match.params.courseId, match.params.chapterId));
    }
  }
  render() {
    const { match, lessonsLoaded } = this.props;

    if (!lessonsLoaded) {
      return <Loading />;
    }

    return (
      <Switch>
        <Route exact path={`${match.path}/:id`} component={LessonEditPage} />
        <Redirect to={`/courses/${match.params.courseId}`} />
      </Switch>
    );
  }
}

const mapStateToProps = state => {
  return {
    lessonsLoaded: state.courses.lessons.get('loaded'),
  };
};

export default connect(mapStateToProps)(Lessons);



// WEBPACK FOOTER //
// ./src/courses/lessons/Lessons.js